import { useAuthUserStore } from '~/store/auth-user';
import { useOrganizationStore } from '~/store/organization';
import { resolveDefaultLandingUrl } from '~/composables/use-default-landing-url';
import { navigateTo } from '#imports';
import { getFirstQueryParam } from '~/utils/common';

export const authForbidden = defineNuxtRouteMiddleware((to) => {
  const authUser = useAuthUserStore();
  const { organization } = storeToRefs(useOrganizationStore());

  if (authUser.isLoggedIn) {
    const queryRedirect = getFirstQueryParam(to.query.redirect);
    const redirect =
      typeof queryRedirect === 'string' && queryRedirect.startsWith('/')
        ? queryRedirect
        : null;

    return navigateTo(redirect ?? resolveDefaultLandingUrl(organization.value));
  }
});
